import "./StructuralProducts.module.css";
import Header from "@/reusable_sections/Header";
import ProductCategoryHeader from "./sections/ProductCategoryHeader";
import SubProductsGrid from "./sections/SubProductsGrid";
import Footer from "@/reusable_sections/Footer";
export default function StructuralProductsPage() {
  return <div>
      <Header />
      <ProductCategoryHeader />
      <SubProductsGrid />
      <Footer />
    </div>;
}